import { FC, useState, useEffect } from 'react'
import { App } from '@capacitor/app'
import { Device } from '@capacitor/device'
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { Typography } from '@mui/material'

const AppVersion: FC = () => {
  const [version, setVersion] = useState<string | null>(null)

  useEffect(() => {
    Device.getInfo().then((info) => {
      if (info.platform === 'web') {
        return
      }

      Promise.all([
        App.getInfo(),
        CapacitorUpdater.current().catch(() => null)
      ]).then(([app, current]) => {
        const nativeVersion = app.version
        const bundleVersion = current?.bundle.version

        if (bundleVersion && bundleVersion !== 'builtin' && bundleVersion !== nativeVersion) {
          setVersion(`${nativeVersion} (${bundleVersion})`)
          return
        }

        setVersion(nativeVersion)
      })
    })
  }, [])

  if (version) {
    return (
      <Typography
        variant='caption'
        sx={{
          display: 'block',
          textAlign: 'center',
          width: '100%'
        }}>
        Ver.: {version}
      </Typography>
    )
  }

  return null
}

export default AppVersion
